import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class ForgotPwd extends EntityDto implements IEntityDto  {
   UserName : string;
   Email: string;
   PhoneNumber : string;
   Otp : number;
   OldPassword : string;
   NewPassword:string;
   ConfirmPassword : string;
   UserId : number;
   password : string;


    constructor() {
        super();
        this.password = "";
        this.UserId = 0;
        this.UserName = "";
        this.Email = "";
        this.PhoneNumber = "";
        this.Otp = 0;
        this.OldPassword = "";
        this.NewPassword = "";
       this.ConfirmPassword = "";



         this.EntityMetaData = [
           { FieldName: 'UserName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Name is required' },
        //     { FieldName: 'Email', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Email is required' },
        //     { FieldName: 'PhoneNumber',FieldType:FieldType.String,IsMandatory:true,ValidationMessage :'PhoneNumber is required'},
             { FieldName: 'Otp',FieldType:FieldType.Key,IsMandatory : true,ValidationMessage:' Enter OTP' },
             { FieldName:'password',FieldType:FieldType.String,IsMandatory :true,ValidationMessage :'Password required'},
        //     { FieldName:'newPassword',FieldType:FieldType.String,IsMandatory : true,ValidationMessage:'Enter New Password'},
        //     { FieldName:'confirmpassword',FieldType:FieldType.String,IsMandatory:true,ValidationMessage:'Reenter New Password'}

         ];
    }
}
